module.exports = __webpack_public_path__ + "img/H1.b43133fb.png";